module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionXscj.3b6e2390.png";